import React from "react";
import styles from "./BetTableLucky7.module.css";

// Helper function to map card name to image path
const getCardImage = (cardName) => {
  const cardMap = {
    'A': '/assets/img/aa2/A.png',
    '1': '/assets/img/aa2/A.png',
    '2': '/assets/img/aa2/2.png',
    '3': '/assets/img/aa2/3.png',
    '4': '/assets/img/aa2/4.png',
    '5': '/assets/img/aa2/5.png',
    '6': '/assets/img/aa2/6.png',
    '7': '/assets/img/aa2/7.png',
    '8': '/assets/img/aa2/8.png',
    '9': '/assets/img/aa2/9.png',
    '10': '/assets/img/aa2/10.png',
    'J': '/assets/img/aa2/J.png',
    'Q': '/assets/img/aa2/Q.png',
    'K': '/assets/img/aa2/K.png'
  };
  return cardMap[cardName] || '/assets/img/aa2/A.png';
};

// Format min/max values
const formatLimit = (value) => {
  if (!value) return "100.0";
  if (value >= 1000) {
    return `${(value / 1000).toFixed(0)}K`;
  }
  return value.toFixed(1);
};

// Helper to normalize string for matching
const normalizeString = (str) => {
  if (!str) return "";
  return str.replace(/\s+/g, ' ').trim().toLowerCase();
};

// Helper to create all exposure key variations
const createExposureKeys = (selection) => {
  if (!selection) return [];
  const keys = [
    selection,
    selection.toLowerCase(),
    selection.toLowerCase().trim(),
    selection.trim(),
    normalizeString(selection),
  ];
  return [...new Set(keys.filter(k => k))];
};

const BetTableLucky7 = ({ data = {}, sub = [], exposures = {} }) => {
  const {
    lowCardData = { b: 0, nat: "Low Card" },
    highCardData = { b: 0, nat: "High Card" },
    evenData = { b: 0, nat: "Even" },
    oddData = { b: 0, nat: "Odd" },
    redData = { b: 0, nat: "Red" },
    blackData = { b: 0, nat: "Black" },
    bottomCards = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"],
  } = data;

  // Helper to check if an item is locked
  const isItemLocked = (item) => {
    if (!item) return true;
    return item.b === 0 || item.gstatus === "SUSPENDED" || item.gstatus === "0";
  };

  // Get exposure value for a bet
  const getExposure = (betName) => {
    if (!exposures || Object.keys(exposures).length === 0) {
      return 0;
    }

    const keys = createExposureKeys(betName);
    for (const key of keys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue) && expValue !== 0) {
          return expValue;
        }
      }
    }
    return 0;
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (!value || value === 0) return "0";
    return value < 0 ? value.toFixed(0) : `+${value.toFixed(0)}`;
  };

  // Display odds value
  const displayOdds = (value, item = null) => {
    if (value === undefined || value === null) return "0";
    if (item && isItemLocked(item)) return "0";
    return value === 0 ? "0" : value.toFixed(2);
  };

  // Find data from sub array
  const lowCardDataFromSub = sub.find(item => item?.nat === "Low Card") || { b: 0, nat: "Low Card" };
  const highCardDataFromSub = sub.find(item => item?.nat === "High Card") || { b: 0, nat: "High Card" };
  const evenDataFromSub = sub.find(item => item?.nat === "Even") || { b: 0, nat: "Even" };
  const oddDataFromSub = sub.find(item => item?.nat === "Odd") || { b: 0, nat: "Odd" };
  const redDataFromSub = sub.find(item => item?.nat === "Red") || { b: 0, nat: "Red" };
  const blackDataFromSub = sub.find(item => item?.nat === "Black") || { b: 0, nat: "Black" };

  const lowCardFinal = { ...lowCardData, ...lowCardDataFromSub };
  const highCardFinal = { ...highCardData, ...highCardDataFromSub };
  const evenFinal = { ...evenData, ...evenDataFromSub };
  const oddFinal = { ...oddData, ...oddDataFromSub };
  const redFinal = { ...redData, ...redDataFromSub };
  const blackFinal = { ...blackData, ...blackDataFromSub };

  const lowCardExposure = getExposure("Low Card");
  const highCardExposure = getExposure("High Card");
  const evenExposure = getExposure("Even");
  const oddExposure = getExposure("Odd");
  const redExposure = getExposure("Red");
  const blackExposure = getExposure("Black");

  return (
    <div>
      {/* Top Section: Low Card | Card 7 | High Card */}
      <div className="card-content lucky-seven-content m-t-10">
        <div className="row">
          <div style={{ color: 'white' }} className="col-5 text-center">
            <b>{displayOdds(lowCardFinal?.b, lowCardFinal)}</b>
          </div>
          <div className="col-2"></div>
          <div style={{ color: 'white' }} className="col-5 text-center">
            <b>{displayOdds(highCardFinal?.b, highCardFinal)}</b>
          </div>
        </div>
        <div className="row m-t-10">
          <div className="col-5 text-center">
            <button className={`text-uppercase low-high-btn ${isItemLocked(lowCardFinal) ? styles.suspended : ""}`}>
              <b>Low Card</b>
            </button>
            <div className="ubook text-center m-t-5 m-l-5">
              <b><span style={{ color: 'black' }}>{formatExposure(lowCardExposure)}</span></b>
            </div>
          </div>
          <div className="col-2 text-center card-seven">
            <img src={getCardImage("7")} alt="7" />
          </div>
          <div className="col-5 text-center">
            <button className={`text-uppercase low-high-btn ${isItemLocked(highCardFinal) ? styles.suspended : ""}`}>
              <b>High Card</b>
            </button>
            <div className="ubook text-center m-t-5 m-l-5">
              <b><span style={{ color: 'black' }}>{formatExposure(highCardExposure)}</span></b>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-right">
            <span className="m-r-5">
              <b>Min:</b> <span>{lowCardFinal?.min ? formatLimit(lowCardFinal.min) : "100"}</span>
            </span>
            <span className="m-r-5">
              <b>Max:</b> <span>{lowCardFinal?.max ? formatLimit(lowCardFinal.max) : "100K"}</span>
            </span>
          </div>
        </div>
      </div>

      {/* Middle Section: Even/Odd and Red/Black */}
      <div className="row">
        <div className="col-6">
          <div className="card-content lucky-seven-content m-t-10">
            <div className="row">
              <div style={{ color: 'white' }} className="col-6 text-center">
                <b style={{ color: 'white' }}>{displayOdds(evenFinal?.b, evenFinal)}</b>
              </div>
              <div style={{ color: 'white' }} className="col-6 text-center">
                <b style={{ color: 'white' }}>{displayOdds(oddFinal?.b, oddFinal)}</b>
              </div>
            </div>
            <div className="row m-t-10">
              <div className="col-6 text-center">
                <button className={`text-uppercase low-high-btn ${isItemLocked(evenFinal) ? styles.suspended : ""}`}>
                  <b>Even</b>
                </button>
                <div style={{ color: 'white' }} className="ubook text-center m-t-5 m-l-5">
                  <b><span style={{ color: 'black' }}>{formatExposure(evenExposure)}</span></b>
                </div>
              </div>
              <div className="col-6 text-center">
                <button className={`text-uppercase low-high-btn ${isItemLocked(oddFinal) ? styles.suspended : ""}`}>
                  <b>Odd</b>
                </button>
                <div className="ubook text-center m-t-5 m-l-5">
                  <b><span style={{ color: 'black' }}>{formatExposure(oddExposure)}</span></b>
                </div>
              </div>
            </div>
            <div  style={{ color: 'white' }} className="row m-t-10">
              <div className="col-12 text-right">
                <span className="m-r-5">
                  <b>Min:</b> <span>100</span>
                </span>
                <span className="m-r-5">
                  <b>Max:</b> <span>25K</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="card-content lucky-seven-content m-t-10">
            <div className="row">
              <div style={{ color: 'white' }} className="col-6 text-center">
                <b>{displayOdds(redFinal?.b, redFinal)}</b>
              </div>
              <div style={{ color: 'white' }} className="col-6 text-center">
                <b>{displayOdds(blackFinal?.b, blackFinal)}</b>
              </div>
            </div>
            <div className="row m-t-10">
              <div className="col-6 text-center">
                <button className={`text-uppercase low-high-btn ${isItemLocked(redFinal) ? styles.suspended : ""}`}>
                  <span className="card-icon">
                    <span className="card-red">♥</span>
                  </span>
                  <span className="card-icon">
                    <span className="card-red">♦</span>
                  </span>
                </button>
                <div className="ubook text-center m-t-5 m-l-5">
                  <b><span style={{ color: 'black' }}>{formatExposure(redExposure)}</span></b>
                </div>
              </div>
              <div className="col-6 text-center">
                <button className={`text-uppercase low-high-btn ${isItemLocked(blackFinal) ? styles.suspended : ""}`}>
                  <span className="card-icon">
                    <span className="card-black">♠</span>
                  </span>
                  <span className="card-icon">
                    <span className="card-black">♣</span>
                  </span>
                </button>
                <div className="ubook text-center m-t-5 m-l-5">
                  <b><span style={{ color: 'black' }}>{formatExposure(blackExposure)}</span></b>
                </div>
              </div>
            </div>
            <div style={{ color: 'white' }} className="row m-t-10">
              <div className="col-12 text-right">
                <span style={{ color: 'white' }} className="m-r-5">
                  <b>Min:</b> <span>100</span>
                </span>
                <span style={{ color: 'white' }} className="m-r-5">
                  <b>Max:</b> <span>25K</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Cards Section */}
      <div className="card-content lucky-seven-content m-t-10">
        <div className="row">
          <div style={{ color: 'white' }} className="col-12 text-center">
            <b>12</b>
          </div>
        </div>
        <div className="row m-t-10">
          <div className="col-12 text-center card-seven">
            {bottomCards.map((card) => {
              const cardName = card === "A" ? "Card 1" :
                card === "J" ? "Card J" :
                  card === "Q" ? "Card Q" :
                    card === "K" ? "Card K" :
                      `Card ${card}`;
              const cardData = sub.find(item => item?.nat === cardName) || { b: 0 };
              const cardIsLocked = isItemLocked(cardData);
              const cardExposure = getExposure(cardName);

              return (
                <div key={card} className="m-r-5 card-image">
                  <div className={cardIsLocked ? styles.suspended : ""}>
                    <img src={getCardImage(card)} alt={card} />
                  </div>
                  <div className="ubook text-center m-t-5">
                    <b><span style={{ color: 'black' }}>{formatExposure(cardExposure)}</span></b>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="row m-t-10">
          <div style={{ color: 'white' }} className="col-12 text-right">
            <span style={{ color: 'white' }} className="m-r-5">
              <b>Min:</b> <span>100</span>
            </span>
            <span style={{ color: 'white' }} className="m-r-5">
              <b>Max:</b> <span>5K</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetTableLucky7;

